<template>
  <div>
    <div v-if="contact">
      <p v-if="!!email" style="font-size: 16px; margin-bottom: 0">
        {{ $t('email_label') }} {{ email }}
      </p>
      <p v-if="!!telephone" style="font-size: 16px; margin-bottom: 0">
        {{ $t('telephone_label') }} {{ telephone }}
      </p>

      <a v-if="!!href_website" :href="href_website" target="_blank">
        {{ $t('website_label') }} {{ website }}
      </a>
      <p v-else-if="!!website">{{ $t('website_label') }} {{ website }}</p>
    </div>
    <p v-else>-</p>
  </div>
</template>

<script>
import { saveGet } from '@/mixins/saveGet'

export default {
  name: 'Contact',
  props: ['contact'],
  mixins: [saveGet],
  computed: {
    email() {
      return this.saveGet(this.contact, '', 'email')
    },
    telephone() {
      return this.saveGet(this.contact, '', 'telephone')
    },
    website() {
      return this.saveGet(this.contact, '', 'website')
    },
    href_website() {
      var re = this.saveGet(this.contact, '', 'website')
      if (!!re && re.startsWith('http')) {
        return re
      }
      return undefined
    }
  },
  i18n: {
    messages: {
      de: {
        email_label: 'Email:',
        telephone_label: 'Telefon:',
        website_label: 'Webseite:'
      },
      en: {
        email_label: 'E-Mail:',
        telephone_label: 'Telephone:',
        website_label: 'Web:'
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Contact.vue